import { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useBrandPriceReferenceSupplierUpdateMutation, useBrandSupplierSelectListQuery } from 'api';
import { Form, notification } from 'components';
import { ErrorMappingValueType } from 'typings';
import { IPriceReferenceSupplierModal } from './index';

export const usePriceReferenceSupplierEditModal = (props: IPriceReferenceSupplierModal) => {
  const { onModalStateChange, modalState, dataToEdit } = props;
  const [form] = Form.useForm();
  const { id } = useParams() as { id: string };
  const [updateBrandPriceReferenceSupplier, { isLoading }] = useBrandPriceReferenceSupplierUpdateMutation();
  const { data: brandSupplierSelectList = [] } = useBrandSupplierSelectListQuery({ brandId: id });

  const [notificationApi, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = useCallback(
    (messageContent: ErrorMappingValueType) => {
      const { type, message } = messageContent;
      notificationApi[type]({
        message: message,
      });
    },
    [notificationApi]
  );

  const onCancel = useCallback(() => {
    form.resetFields();
    onModalStateChange();
  }, [form, onModalStateChange]);

  const onFinish = useCallback(() => {
    const payload = form.getFieldsValue() || {};
    payload.brandId = id as string;
    updateBrandPriceReferenceSupplier(payload)
      .then(({ data, error }: any) => {
        if (data?.success) {
          openNotificationWithIcon({
            type: 'success',
            message: 'Brand price reference supplier was successfully updated.',
          });
          onCancel();
        } else if (!error.data.success) {
          const { data = {} } = error.data;
          Object.keys(data).forEach((_key: string) => {
            openNotificationWithIcon({
              type: 'error',
              message: data[_key],
            });
          });
        } else if (error.data.error) {
          openNotificationWithIcon({
            type: 'error',
            message: 'Something went wrong!',
          });
        }
      })
      .catch((err) => {
        console.log(err, 'error');
      });
  }, [form, updateBrandPriceReferenceSupplier, openNotificationWithIcon, id, onCancel]);

  useEffect(() => {
    if (modalState && dataToEdit) {
      form.setFieldsValue(dataToEdit);
    }
  }, [form, modalState, dataToEdit]);

  return {
    contextHolder,
    onFinish,
    onCancel,
    form,
    isLoading,
    brandSupplierSelectList,
  };
};
